import { render } from "./charts-widget.vue?vue&type=template&id=852c6048&scoped=true"
const script = {}

import "./charts-widget.vue?vue&type=style&index=0&id=852c6048&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-852c6048"]])

export default __exports__